module.exports = __webpack_public_path__ + "img/AK0094-PK.b9ebb151.jpg";